export default "__VITE_ASSET__D8W4j8al__"